const AppData = {
    // Application state
    state: {
        setupCompleted: true,
        currentUser: {
            name: 'Admin User',
            email: 'admin@example.com',
            role: 'admin'
        }
    },

    // Mock data for the dashboard
    dashboard: {
        integrationStatus: {
            status: 'Configured',
            statusType: 'success' // success, warning, error
        },
        metrics: {
            knowledgeBases: 3,
            sharePointFiles: 142,
            syncStatus: {
                lastSync: '2h ago',
                statusType: 'success'
            }
        },
        recentActivity: [
            {
                id: '1',
                action: 'Knowledge Base Sync',
                time: '2 hours ago',
                status: 'success',
                description: "Successfully synced 'Customer Support KB'"
            },
            {
                id: '2',
                action: 'SharePoint Connection',
                time: '1 day ago',
                status: 'success',
                description: "Connected to 'Marketing Materials'"
            },
            {
                id: '3',
                action: 'File Import',
                time: '2 days ago',
                status: 'error',
                description: "Failed to import 'Product Catalog.docx'"
            },
            {
                id: '4',
                action: 'Webhook Trigger',
                time: '3 days ago',
                status: 'success',
                description: 'Received update from SharePoint webhook'
            }
        ],
        knowledgeBaseSummary: [
            {
                id: '1',
                name: 'Customer Support KB',
                source: 'Marketing Materials',
                articles: 24,
                lastSynced: '2 hours ago',
                trigger: 'Daily (Cron)',
                status: 'Active'
            },
            {
                id: '2',
                name: 'Technical Documentation',
                source: 'Product Documentation',
                articles: 18,
                lastSynced: '1 day ago',
                trigger: 'Weekly',
                status: 'Active'
            },
            {
                id: '3',
                name: 'Sales Resources',
                source: 'Sales SharePoint',
                articles: 12,
                lastSynced: '3 days ago',
                trigger: 'Manual',
                status: 'Active'
            }
        ]
    },

    // Mock data for the setup
    setup: {
        oauthCredentials: {
            clientName: 'SharePoint KB Connector',
        },
        roles: [
            {
                id: 'admin',
                name: 'SharePoint Connector Admin',
                description: 'Full access to create and manage knowledge bases, SharePoint connections, and trigger configurations',
                selected: true
            },
            {
                id: 'view',
                name: 'SharePoint Connector View',
                description: 'Can view knowledge bases and SharePoint content, but cannot modify settings',
                selected: true
            },
            {
                id: 'integration',
                name: 'Knowledge Base Integration',
                description: 'System role for the integration to access Genesys Knowledge Base APIs',
                selected: true
            }
        ],
        resourceSummary: {
            oauthClient: {
                clientName: 'SharePoint KB Connector',
                grantTypes: ['Authorization Code', 'Refresh Token'],
                scopes: ['knowledge:read', 'knowledge:write']
            },
            roles: [
                'SharePoint Connector Admin',
                'SharePoint Connector View',
                'Knowledge Base Integration'
            ],
            permissions: [
                {
                    role: 'SharePoint Connector Admin',
                    access: 'Full access to all features'
                },
                {
                    role: 'SharePoint Connector View',
                    access: 'Read-only access to content'
                },
                {
                    role: 'Knowledge Base Integration',
                    access: 'API access for system operations'
                }
            ]
        }
    },

    // Mock data for SharePoint configurations
    sharePointConfig: {
        connections: [
            {
                id: '1',
                name: 'Marketing Materials',
                url: 'https://company.sharepoint.com/sites/marketing',
                status: 'Connected',
                lastValidated: '2 hours ago'
            },
            {
                id: '2',
                name: 'Product Documentation',
                url: 'https://company.sharepoint.com/sites/products',
                status: 'Connected',
                lastValidated: '1 day ago'
            }
        ],
        newConnection: {
            name: 'Technical Documentation',
            url: 'https://company.sharepoint.com/sites/techdocs',
            authMethod: 'App Registration',
            clientId: '12345678-abcd-1234-efgh-123456789abc',
            clientSecret: ''
        }
    },

    // Mock data for knowledge bases
    knowledgeBase: {
        bases: [
            {
                id: '1',
                name: 'Customer Support KB',
                description: 'Knowledge base for customer support agents',
                articles: 24,
                lastSync: '2 hours ago',
                status: 'Active'
            },
            {
                id: '2',
                name: 'Technical Documentation',
                description: 'Technical specifications and guides',
                articles: 18,
                lastSync: '1 day ago',
                status: 'Active'
            },
            {
                id: '3',
                name: 'Sales Resources',
                description: 'Sales collateral and pricing information',
                articles: 12,
                lastSync: '3 days ago',
                status: 'Active'
            }
        ],
        newBase: {
            name: 'Product Support Documentation',
            description: 'Knowledge base for product support agents containing troubleshooting guides and product documentation.',
            language: 'English'
        },
        sharePointContent: [
            {
                id: '1',
                name: 'Product Guides',
                type: 'Folder',
                path: '/sites/docs/Product Guides'
            },
            {
                id: '2',
                name: 'Marketing Materials',
                type: 'Folder',
                path: '/sites/docs/Marketing Materials'
            },
            {
                id: '3',
                name: 'Troubleshooting Guide.pdf',
                type: 'File',
                path: '/sites/docs/Troubleshooting Guide.pdf'
            },
            {
                id: '4',
                name: 'Customer FAQ.docx',
                type: 'File',
                path: '/sites/docs/Customer FAQ.docx'
            }
        ]
    },

    // Mock data for trigger configuration
    triggerConfig: {
        triggerTypes: [
            {
                id: 'cron',
                name: 'Scheduled Batch Process (Cron)',
                selected: true
            },
            {
                id: 'adhoc',
                name: 'Ad-hoc Update',
                selected: false
            },
            {
                id: 'webhook',
                name: 'SharePoint Webhook',
                selected: false
            }
        ],
        cronSchedules: [
            {
                id: 'daily',
                name: 'Daily at midnight',
                expression: '0 0 * * *'
            },
            {
                id: 'weekly',
                name: 'Weekly on Sunday',
                expression: '0 0 * * 0'
            },
            {
                id: 'monthly',
                name: 'Monthly on the 1st',
                expression: '0 0 1 * *'
            },
            {
                id: '6hours',
                name: 'Every 6 hours',
                expression: '0 */6 * * *'
            },
            {
                id: '12hours',
                name: 'Every 12 hours',
                expression: '0 */12 * * *'
            }
        ],
        currentTrigger: {
            type: 'cron',
            schedule: 'daily',
            cronExpression: '0 0 * * *'
        }
    },

    // Mock data for activity logs
    activityLogs: {
        filters: {
            dateRange: 'last7days',
            status: 'all',
            actionType: 'all'
        },
        logs: [
            {
                id: '1',
                timestamp: '2025-04-28 14:30:00',
                action: 'Knowledge Base Sync',
                status: 'Success',
                details: "Successfully synced 'Customer Support KB'"
            },
            {
                id: '2',
                timestamp: '2025-04-27 10:15:00',
                action: 'SharePoint Connection',
                status: 'Success',
                details: "Connected to 'Marketing Materials'"
            },
            {
                id: '3',
                timestamp: '2025-04-26 16:45:00',
                action: 'File Import',
                status: 'Failed',
                details: "Failed to import 'Product Catalog.docx'"
            },
            {
                id: '4',
                timestamp: '2025-04-25 09:20:00',
                action: 'Setup Completed',
                status: 'Success',
                details: 'Initial setup completed'
            },
            {
                id: '5',
                timestamp: '2025-04-24 13:10:00',
                action: 'Webhook Trigger',
                status: 'Success',
                details: 'Received update from SharePoint webhook'
            },
            {
                id: '6',
                timestamp: '2025-04-23 11:05:00',
                action: 'Knowledge Base Creation',
                status: 'Success',
                details: 'Created Technical Support knowledge base'
            },
            {
                id: '7',
                timestamp: '2025-04-22 15:30:00',
                action: 'File Import',
                status: 'In Progress',
                details: 'Importing Training Material.pptx'
            }
        ],
        pagination: {
            total: 23,
            current: 1,
            perPage: 7
        }
    },

    // Mock data for help and support
    helpAndSupport: {
        topics: [
            {
                id: 'getting-started',
                name: 'Getting Started',
                icon: 'FileText',
                selected: true
            },
            {
                id: 'sharepoint-config',
                name: 'SharePoint Configuration',
                icon: 'Database',
                selected: false
            },
            {
                id: 'knowledge-base',
                name: 'Knowledge Base',
                icon: 'FileText',
                selected: false
            },
            {
                id: 'trigger-config',
                name: 'Trigger Configuration',
                icon: 'Clock',
                selected: false
            },
            {
                id: 'troubleshooting',
                name: 'Troubleshooting',
                icon: 'AlertTriangle',
                selected: false
            },
            {
                id: 'faq',
                name: 'FAQ',
                icon: 'HelpCircle',
                selected: false
            }
        ],
        content: {
            'getting-started': [
                {
                    id: 'initial-setup',
                    title: 'Initial setup process',
                    content: 'Complete the initial setup to create necessary OAuth credentials, roles, and groups in Genesys Cloud. Go to the Initial Setup page and follow the step-by-step wizard. This process only needs to be done once when first installing the connector.'
                },
                {
                    id: 'first-kb',
                    title: 'Creating your first knowledge base',
                    content: 'Once the initial setup is complete, you can create your first knowledge base and map it to SharePoint content. Navigate to the Knowledge Base Management page and click "Create Knowledge Base". Follow the wizard to configure your knowledge base name, description, and select SharePoint content to include.'
                },
                {
                    id: 'dashboard',
                    title: 'Understanding the dashboard',
                    content: 'The dashboard provides an overview of your integration status, knowledge bases, and recent activity. You can see sync status, take quick actions, and monitor the health of your integration from this central location.'
                }
            ]
        }
    },

    // Navigation structure
    navigation: [
        {
            id: 'dashboard',
            name: 'Dashboard',
            path: '/',
            icon: 'Home',
            requiresSetup: false,
            active: true,
            adminOnly: false,
            liscenseClientOnly: true
        },
        {
            id: 'setup',
            name: 'Initial Setup',
            path: '/setup',
            icon: 'Settings',
            requiresSetup: false,
            active: false,
            adminOnly: false,
            liscenseClientOnly: true
        },
        {
            id: 'sharepoint',
            name: 'SharePoint Config',
            path: '/sharepoint',
            icon: 'Database',
            requiresSetup: true,
            active: false,
            adminOnly: true,
            liscenseClientOnly: true
        },
        {
            id: 'knowledge-base',
            name: 'Knowledge Base',
            path: '/knowledge-base',
            icon: 'FileText',
            requiresSetup: true,
            active: false,
            adminOnly: false,
            liscenseClientOnly: true
        },
        {
            id: 'trigger-config',
            name: 'Trigger Config',
            path: '/trigger-config',
            icon: 'Clock',
            requiresSetup: true,
            active: false,
            adminOnly: true,
            liscenseClientOnly: true
        },
        {
            id: 'logs',
            name: 'Activity Logs',
            path: '/logs',
            icon: 'BarChart2',
            requiresSetup: false,
            active: false,
            adminOnly: false,
            liscenseClientOnly: true
        },
        {
            id: 'releasenotes',
            name: 'Release Notes',
            path: '/releasenotes',
            icon: 'ScrollText',
            requiresSetup: false,
            active: false,
            adminOnly: false,
            liscenseClientOnly: true
        },
        {
            id: 'help',
            name: 'Help & Support',
            path: '/help',
            icon: 'HelpCircle',
            requiresSetup: false,
            active: false,
            adminOnly: false,
            liscenseClientOnly: true
        }
    ]
};

export default AppData;